export enum ProductId {
  AGENT = 3,
  ATS = 2,
  TALENT = 1,
}

export const UserRoleNameToIdMap = {
  // 企业端角色
  /** 超级管理员 */
  ROLE_BUSINESS_SUPER_ADMIN:  1,
  /** 招聘主管 */
  ROLE_BUSINESS_RECRUIT_MANAGER:  4,
  /** 招聘专员 */
  ROLE_BUSINESS_RECRUITER: 5,
  /** 面试官 */
  ROLE_BUSINESS_INTERVIEWER: 6,
  /** 运营支持 猎头端和企业端*/ 
  ROLE_BUSINESS_OPERATION: 7,

  // 猎头端角色
  ROLE_AGENT_ADMIN: 2,
  ROLE_AGENT_USER: 3,

  // talent角色
  ROLE_BUSINESS_ADMIN: 2,
  ROLE_BUSINESS_USER: 3,
}
/**
 * 用户角色枚举
 */
export enum UserRole {
  /** 超级管理员 */
  SUPER_ADMIN = UserRoleNameToIdMap.ROLE_BUSINESS_SUPER_ADMIN,
  /** 招聘主管 */
  RECRUITMENT_MANAGER = UserRoleNameToIdMap.ROLE_BUSINESS_RECRUIT_MANAGER,
  /** 招聘专员 */
  RECRUITMENT_SPECIALIST = UserRoleNameToIdMap.ROLE_BUSINESS_RECRUITER,
  /** 面试官 */
  INTERVIEWER = UserRoleNameToIdMap.ROLE_BUSINESS_INTERVIEWER,

  // 运营支持
  ROLE_BUSINESS_OPERATION = UserRoleNameToIdMap.ROLE_BUSINESS_INTERVIEWER,

  // 猎头端角色
  BUSINESS_ADMIN = UserRoleNameToIdMap.ROLE_AGENT_ADMIN,
  ROLE_AGENT_USER = UserRoleNameToIdMap.ROLE_AGENT_USER,
}

/**
 * 权限操作类型
 */
export enum PermissionAction {
  /** 查看权限 */
  SHOW = 'show',
  /** 编辑/管理权限 */
  EDIT = 'edit',
  /** 下载权限 */
  DOWNLOAD = 'download'
}

export const RoleLocalesMap: Record<string, string> = {
  'ROLE_BUSINESS_SUPER_ADMIN': 'account.roles.superAdmin',
  'ROLE_BUSINESS_ADMIN': 'account.roles.admin',
  'ROLE_BUSINESS_RECRUIT_MANAGER': 'account.roles.recruitManager',
  'ROLE_BUSINESS_RECRUITER': 'account.roles.recruiter',
  'ROLE_BUSINESS_USER': 'account.roles.user',
  'ROLE_BUSINESS_OPERATION': 'account.roles.op',
  'ROLE_BUSINESS_INTERVIEWER': 'account.roles.interviewer'
}